import { render, staticRenderFns } from "./SkillformLeaderboard.vue?vue&type=template&id=6f198c2e&scoped=true&"
import script from "./SkillformLeaderboard.vue?vue&type=script&lang=js&"
export * from "./SkillformLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./SkillformLeaderboard.vue?vue&type=style&index=0&id=6f198c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f198c2e",
  null
  
)

export default component.exports